import { useState, useRef, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import { useLocation } from "react-router-dom";

import { serviceReminders } from "../../_helpers/service-rem";
import { requestDeclauter } from "../../services/entrepellung/entrepelung.context";
import { Loader } from "../utilities/loader";
import { projectData } from "../../_helpers/project-data";
import { AppAlert } from "../utilities/alert";

export const ContactForm = () => {

    const [serviceData, setServiceData] = useState({
        names: "",
        email: "",
        phoneNumber: "",
        description: "",
        service: "",
        housesize: ""
    });

    const [onAlert, setOnAlert] = useState();

    const [loading, setLoading] = useState(false);

    const [termsChecked, setTermsChecked] = useState(false);

    const project = useLocation()?.state?.project;

    const namesRef = useRef();
    const serviceRef = useRef();
    const emailRef = useRef();
    const descrRef = useRef();
    const phoneRef = useRef();
    const sizeRef = useRef();

    const refList = {
        "names": namesRef,
        "service": serviceRef,
        "description": descrRef,
        "email": emailRef,
        "phoneNumber": phoneRef,
        "housesize": sizeRef
    }


    const invalids = [];

    const handleValidateDate = () => {
        const isNull = (value) => value === "" || value === null || value === undefined;
        Object.keys(serviceData).forEach((elem) => {
            if (isNull(serviceData[elem])) {
                invalids.push(elem);
            }
            else invalids.filter((e) => e !== elem)
        });

        if (invalids.length > 0) {
            let firstRef = refList[invalids[0]];
            //alert(`${firstRef} is Null!`);
            firstRef.current.scrollIntoView({ behavior: 'smooth', block: "start" });
            firstRef.current.focus();
            return false;
        } else return true;
    }

    const handleInput = (e) => {
        e.preventDefault();
        setServiceData((v) => ({ ...v, [e.target.name]: e.target.value }));
    }

    const handleSubmit = async () => {

        if (termsChecked === false) {
            alert('Bitte akzeptieren Sie die Allgemeinen Geschäftsbedingungen, um fortzufahren!');
            return;
        }

        if (handleValidateDate() === true) {
            //console.log(serviceData);
            setLoading(true);
            const resp = await requestDeclauter(serviceData);
            console.log(resp);
            setLoading(false);
            setOnAlert({
                caption: "Erfolg!",
                message: resp?.message,
                accept: "Ok",
                onAccept: () => {
                    setOnAlert();
                    window.location.reload();
                }
            })
        }
    }

    useEffect(() => {
        setServiceData((d) => ({ ...d, service: project }));
        setServiceData((d) => ({...d, housesize: 0}))
    }, [project])

    return (
        <div className="flx-col contact-form-container c-al">
            {loading && <Loader />}
            {onAlert && (
                <AppAlert
                    caption={onAlert.caption}
                    message={onAlert.message}
                    accept={onAlert.accept}
                    onAccept={onAlert.onAccept}
                    onClose={() => {
                        setOnAlert();
                        window.location.reload();
                    }}
                />
            )}
            <div className="form-caption">Kostenloses Angebot anfordern</div>
            <div className="form-description">
                Wir melden uns innerhalb von 24 Stunden bei Ihnen zurück
            </div>
            <form
                className="contact-form"
                onSubmit={async (e) => {
                    e.preventDefault();
                    await handleSubmit();
                }}
            >
                <div className="container-pair">
                    <div className="input-container">
                        <div className="input-caption">
                            <span className="caption-name">Ihr Name</span>
                            <span className="req">*</span>
                        </div>
                        <input
                            type="text"
                            ref={namesRef}
                            name="names"
                            id="names"
                            className="form-input"
                            placeholder="John Doe"
                            onChange={(e) => handleInput(e)}
                        />
                    </div>
                    <div className="input-container">
                        <div className="input-caption">
                            <span className="caption-name">E-Mail Adresse</span>
                            <span className="req">*</span>
                        </div>
                        <input
                            type="email"
                            name="email"
                            ref={emailRef}
                            id="names"
                            className="form-input"
                            placeholder="johnDoe@mail.de"
                            onChange={(e) => handleInput(e)}
                        />
                    </div>
                </div>
                <div className="container-pair">
                    <div className="input-container">
                        <div className="input-caption">
                            <span className="caption-name">Telefon</span>
                            <span className="req">(optional)</span>
                        </div>
                        <input
                            type="tel"
                            name="phoneNumber"
                            id="phoneNumber"
                            ref={phoneRef}
                            className="form-input"
                            placeholder="+4917622006681"
                            onChange={(e) => handleInput(e)}
                        />
                    </div>
                    <div className="input-container">
                        <div className="input-caption">
                            <span className="caption-name">Gewünschter Service</span>
                            <span className="req">*</span>
                        </div>
                        <select
                            id="service"
                            name="service"
                            className="form-input select-service"
                            ref={serviceRef}
                            onChange={(e) => {
                                e.preventDefault();
                                handleInput(e);
                            }}
                            value={serviceData?.service}
                        >
                            <option value="">Bitte wählen...</option>
                            {projectData.map((proj, indx) => (
                                <option value={proj.project} key={indx}>
                                    {proj.project}
                                </option>
                            ))}
                        </select>
                    </div>
                </div>
                <div className="input-container size">
                    <div className="input-caption">
                        <span className="caption-name">Wohnungsgröße (Quadratmeter)</span>
                        <span className="req">*</span>
                    </div>
                    <input
                        type="number"
                        name="housesize"
                        id="housesize"
                        ref={sizeRef}
                        value={serviceData?.housesize}
                        className="form-input"
                        placeholder="35"
                        onChange={(e) => handleInput(e)}
                        disabled={ project === 'Courierdienst' }
                    />
                </div>
                <div className="input-container msg-container">
                    <div className="input-caption">
                        <span className="caption-name">Ihre Nachricht</span>
                        <span className="req">*</span>
                    </div>
                    <textarea
                        name="description"
                        id=""
                        cols="30"
                        rows="10"
                        placeholder="Beschreiben Sie Ihr Anliegen... (z.B. Größe der Wohnung, gewünschter Termin, besondere Anforderungen)"
                        className="form-input msg-input"
                        ref={descrRef}
                        onChange={(e) => handleInput(e)}
                    >
                    </textarea>

                </div>

                <div className="service-reminders">
                    <div className="rem-caption">
                        <FontAwesomeIcon icon={faInfoCircle} className="info-icon" />
                        <span className="info-caption-text">
                            Unser Service:
                        </span>
                    </div>
                    <div className="rem-list flx-col">
                        {serviceReminders.map((rem) => (
                            <div className="rem-item flx-rw">
                                <FontAwesomeIcon
                                    icon={faCheck}
                                    className="rem-check"
                                />
                                <span className="rem-text">{rem}</span>
                            </div>
                        ))}
                    </div>
                </div>

                <div className="service-terms-box flx-rw">
                    <input
                        type="checkbox"
                        checked={termsChecked === true}
                        className="term-check"
                        onChange={(e) => {
                            setTermsChecked((v) => !v)
                        }}
                    />
                    <span className="terms-list">
                        Ich habe die <a href="/privacy"> Datenschutzerklärung </a>gelesen und stimme der Verarbeitung meiner personenbezogenen Daten zur Bearbeitung meiner Anfrage zu. Die Einwilligung kann jederzeit widerrufen werden. *
                    </span>
                </div>
                <div className="service-reminders small-txt">
                    <strong>Hinweis: </strong>
                    <span>Ihre Daten werden ausschließlich zur Bearbeitung Ihrer Anfrage verwendet und nicht an Dritte weitergegeben. Sie können der Verarbeitung jederzeit widersprechen oder die Löschung Ihrer Daten verlangen.</span>
                </div>
                <div className="form-submit flx-rw c-al c-jt">
                    <button className="submit-button">Kostenloses Angebot anfordern</button>
                </div>
            </form>
        </div>
    );
}